import { render } from "./RafflesElement.vue?vue&type=template&id=b938c038"
import script from "./RafflesElement.vue?vue&type=script&lang=js"
export * from "./RafflesElement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__